import React from "react";

export default function MarketCount({
  absoluteSellingMerchantStoreCount,
  productChartsUrl,
}) {
  const marketCount = absoluteSellingMerchantStoreCount || 0;
  // pluralize text:
  const markets =
    marketCount === 1 ? "Abverkaufender Markt" : "Abverkaufende Märkte";

  return (
    <div>
      <strong>
        <a href={productChartsUrl}>
          <i className="fa fa-home" />
          {marketCount}
        </a>
      </strong>
      <small>{markets}</small>
    </div>
  );
}
